var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPintDrop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-725 -581.06)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.069971 0 0 .070175 696.73 562.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.027 0 0 1.0364 -19.102 -20.891)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412,
    y: 272,
    width: 334,
    height: 330,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m586.05 561.6c-2.528 2.915-6.196 4.589-10.054 4.589s-7.526-1.674-10.055-4.589c-25.18-29.486-88.945-110.31-88.945-172.6 0-54.64 44.36-99 99-99s99 44.36 99 99c0 62.292-63.765 143.11-88.946 172.6zm-10.054-208.6c19.317 0 35 15.683 35 35s-15.683 35-35 35-35-15.683-35-35 15.683-35 35-35z",
    fill: "#88869c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPintDrop);
export default __webpack_public_path__ + "static/media/pint_drop.9e8025402c91c1724d5acedd49a0aafd.svg";
export { ForwardRef as ReactComponent };